<script>
import popupSelect from "@/components/base/popup/popupSelect";
import { formSelectConfig } from "@/components/base/conf";

const defaultCancelButtonText = "取消";
const defaultClearButtonText = "清空";

export default {
  name: "formSelect",
  components: {
    popupSelect
  },
  props: {
    //值
    value: {
      type: [String, Number],
      default: ""
    },
    //标题
    title: {
      type: String,
      default: ""
    },
    //标题宽度
    titleWidth: {
      type: String,
      default: ""
    },
    //数据
    options: {
      type: Array,
      default: () => []
    },
    //提示
    placeholder: {
      type: String,
      default: "请选择"
    },
    //是否开启搜索
    search: {
      type: Boolean,
      default: false
    },
    //搜索 过滤参数
    searchFilter: {
      type: [String, Array, Function],
      default: () => formSelectConfig.searchFilter
    },
    //搜索框 提示文字
    searchPlaceholder: {
      type: String,
      default: ""
    },
    //必填
    required: {
      type: Boolean,
      default: false
    },
    //只读
    readonly: {
      type: Boolean,
      default: false
    },
    //禁用
    disabled: {
      type: Boolean,
      default: false
    },
    //数据value 参数
    valueField: {
      type: String,
      default: formSelectConfig.valueField
    },
    //数据text 参数
    labelField: {
      type: String,
      default: formSelectConfig.labelField
    },
    //确认 描述
    confirmButtonText: {
      type: String,
      default: "确认"
    },
    //取消 描述
    cancelButtonText: {
      type: String,
      default: "取消"
    },
    //是否在点击遮罩层后关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      defaultIndex: 0,
      realValue: ""
    };
  },
  watch: {
    realValue(e) {
      if (this.realValue != this.value) {
        this.$emit("input", e);
      }
    },
    value(e) {
      if (this.realValue != this.value) {
        this.realValue = e;
      }
    }
  },
  computed: {},
  created() {
    this.realValue = this.value;
  },
  methods: {
    /**
     * @description: 获取值
     * @param {*}
     * @return {*}
     */
    getValue() {
      return this.realValue;
    },
    /**
     * @description: 赋值
     * @param {*}
     * @return {*}
     */
    setValue(e) {
      this.realValue = e;
    },
    /**
     * @description: 选中当前选中索引
     * @param {*}
     * @return {*}
     */
    findSelectIndex() {
      let index = this.options.findIndex(
        p => p[this.valueField] == this.realValue
      );
      this.defaultIndex = index > -1 ? index : 0;
    },
    /**
     * @description: 显示
     * @param {*}
     * @return {*}
     */
    show() {
      let { readonly, disabled } = this;
      if (!(readonly || disabled)) {
        this.findSelectIndex();
        this.visible = !this.visible;
      }
    },
    /**
     * @description: 确认
     * @param {*} data
     * @return {*}
     */
    confirm(data) {
      let value;
      if (data) {
        value = data[this.valueField];
        this.visible = false;
      }
      this.realValue = value;
      this.$emit("change", value, data);
    },
    /**
     * @description: 取消
     * @param {*}
     * @return {*}
     */
    cancel() {
      if (!this.required) {
        this.confirm("");
      }
    },
    /**
     * @description: 输入框 渲染
     * @param {*}
     * @return {*}
     */
    fieldRender() {
      let { realValue, labelField, valueField, readonly, disabled } = this;
      readonly = readonly || disabled;
      let text = "";
      let row = this.options.find(p => {
        return p[valueField] === realValue;
      });
      if (row) {
        text = row[labelField];
      }
      let option = {
        props: {
          readonly: true,
          value: text,
          label: this.title,
          labelWidth: this.titleWidth,
          required: this.required
        },
        ref: "input"
      };
      if (!readonly) {
        option.props.rightIcon = "arrow-down";
        option.props.placeholder = this.placeholder;
        option.on = {
          click: this.show
        };
      }
      return <van-field {...option} />;
    },
    /**
     * @description: 弹窗 渲染
     * @param {*}
     * @return {*}
     */
    popupSelectRender() {
      let { cancelButtonText, required } = this;
      let option = {
        props: {
          value: this.visible,
          isSelectDefault: true,
          options: this.options,
          valueField: this.valueField,
          labelField: this.labelField,
          defaultIndex: this.defaultIndex,
          search: this.search,
          searchFilter: this.searchFilter,
          searchPlaceholder: this.searchPlaceholder,
          isClear: !required,
          cancelButtonText:
            cancelButtonText != defaultCancelButtonText
              ? cancelButtonText
              : required
              ? defaultCancelButtonText
              : defaultClearButtonText,
          confirmButtonText: this.confirmButtonText,
          closeOnClickOverlay: this.closeOnClickOverlay
        },
        on: {
          input: e => {
            this.visible = e;
          },
          confirm: this.confirm
        }
      };
      return <popupSelect {...option} />;
    }
  },
  render() {
    return (
      <div class="form-select form-item-wraper">
        {this.fieldRender()}
        {this.popupSelectRender()}
      </div>
    );
  }
};
</script>
